import Footer from "../components/Footer";
import TechNavbar from "../components/TechNavbar";
import FadeInSection from "../components/FadeInSection";
import ServicesMiniSection from "../components/Services/ServicesMiniSection";
import PricingSection from "../components/PriceingSection";
import TestimonialsSection from "../components/Testimonial";
import HeroSection from "../components/Services/HeroServices";

const Services = () => {
  return (
    <div className="min-h-screen  bg-white font-sans">
      {/* <Header /> */}
      <TechNavbar />

      <FadeInSection>
        <HeroSection />
      </FadeInSection>

      <FadeInSection>
        <ServicesMiniSection />
      </FadeInSection>

      {/* /////// */}
      <FadeInSection>
        <section class="mx-auto h-min-screen py-10 mt-15 max-w-7xl px-4 sm:mt-6 sm:px-6 lg:mt-12 lg:px-8">
          <div class="lg:flex-justify mx-auto my-10 flex max-w-7xl flex-col gap-3 px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:flex lg:flex-row lg:px-8 xl:mt-8">
            <div class="sm:text-center lg:text-left">
              <h1 class="text-4xl font-extrabold tracking-tight text-gray-800 sm:text-5xl md:text-6xl">
                <span class="block xl:inline">Data to enrich your</span>
                <span class="block text-blue-600 xl:inline">
                  {" "}
                  online business
                </span>
              </h1>
              <p class="mt-3 text-base text-gray-500 sm:mx-auto sm:mt-5 sm:max-w-xl sm:text-lg md:mt-5 md:text-xl lg:mx-0">
                Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui
                lorem cupidatat commodo. Elit sunt amet fugiat veniam occaecat
                fugiat aliqua.
              </p>
              <div class="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                <div class="rounded-md shadow">
                  <a
                    href="/contact"
                    class="flex w-full items-center justify-center rounded-md border border-transparent bg-blue-600 px-8 py-3 text-base font-medium text-white hover:bg-blue-800 md:px-10 md:py-4 md:text-lg"
                  >
                    {" "}
                    Get started{" "}
                  </a>
                </div>
                <div class="mt-3 sm:mt-0 sm:ml-3">
                  <a
                    href="about"
                    class="flex w-full items-center justify-center rounded-md border border-transparent bg-indigo-100 px-8 py-3 text-base font-medium text-gray-800 hover:bg-indigo-200 md:px-10 md:py-4 md:text-lg"
                  >
                    {" "}
                    About Us{" "}
                  </a>
                </div>
              </div>
            </div>

            <div class="lg:inset-y-0 lg:right-0 lg:w-1/2 group cursor-pointer">
              <img
                class="h-96 w-full object-cover sm:h-72 md:h-96 lg:h-full lg:w-full rounded-md transform group-hover:scale-105 transition-transform duration-700"
                src="https://images.unsplash.com/photo-1508780709619-79562169bc64?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt=""
              />
            </div>
          </div>
        </section>
      </FadeInSection>

      {/* /////////// */}

      <FadeInSection>
        <div class="flex  items-center dark:bg-slate-800 py-20">
          <div class="mx-auto mt-10 flex justify-center px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8">
            <div class="px-5 text-center ">
              <h1 class="text-4xl font-extrabold tracking-tight text-gray-900 dark:text-slate-200 sm:text-5xl md:text-6xl">
                <span class="block xl:inline">
                  <span class="mb-1 block">Create amazing</span>
                  <span class="bg-gradient-to-r from-indigo-400 to-blue-600 bg-clip-text text-transparent">
                    Software Solutions
                  </span>
                </span>
                <div class="mt-2">
                  10X faster
                  <span class="relative mt-3 whitespace-nowrap text-blue-600">
                    <span class="relative"> with AI tools.</span>
                  </span>
                </div>
              </h1>
              <p class="mx-auto mt-3 max-w-xl text-lg text-gray-500 dark:text-slate-400 sm:mt-5 md:mt-5">
                We deliver reliable, innovative and cutting-edge software
                solutions that are geared for enterprises of any kind.
              </p>
            </div>
          </div>
        </div>
      </FadeInSection>

      <FadeInSection>
        <div class="relative flex flex-col items-center mx-auto lg:flex-row-reverse lg:max-w-5xl lg:mt-12 xl:max-w-6xl pb-12">
          <div class="w-full h-64 lg:w-1/2 lg:h-auto group cursor-pointer">
            <img
              class="h-full w-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              src="https://images.unsplash.com/photo-1576057122708-9608db46b2f3?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Winding mountain road"
            />
          </div>

          <div class="max-w-lg bg-white md:max-w-2xl md:z-10 md:shadow-lg md:absolute md:top-0 md:mt-48 lg:w-3/5 lg:left-0 lg:mt-20 lg:ml-20 xl:mt-24 xl:ml-12">
            <div class="flex flex-col p-12 md:px-16">
              <h2 class="text-2xl font-medium uppercase text-black lg:text-4xl">
                Mutual Benefits of Partnership
              </h2>
              <p className="mt-4 text-xl font-bold text-blue-600">
                For Partners
              </p>
              <p class="mt-1">
                <li>
                  Receive an official accreditation mark (Yarqin Certification
                  Mark) from a trusted institution
                </li>
                <li>Product promotion through a professional marketing team</li>
                <li>Save on advertising and marketing costs</li>
                <li>Gain customer confidence and increase sales</li>
                <li>
                  Focus on product improvement and innovation without worrying
                  about marketing
                </li>
              </p>
              {/* <div class="mt-8">
                <a
                  href="#"
                  class="inline-block w-full text-center text-lg font-medium text-gray-100 bg-blue-600 rounded-md py-4 px-10 hover:bg-blue-400 hover:shadow-md md:w-48"
                >
                  Read More
                </a>
              </div> */}
            </div>
          </div>
        </div>
      </FadeInSection>
      {/* ////////////////// */}

      <FadeInSection>
        <section class="py-16 md:py-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto font-sans-body">
          <div class="text-center mb-16 space-y-2">
            <h2 class="text-4xl md:text-5xl lg:text-6xl font-serif-display text-gray-900 leading-tight">
              Roles and Activities of{" "}
              <span class="text-blue-600 font-bold ">Yarqin Tech Hub</span>
            </h2>
            {/* <p class="text-gray-500 max-w-2x items-center    text-lg">
                        Our marketing and market analysis team uses advanced data insights and research to:
                    </p> */}
          </div>

          <div class="grid grid-cols-1 lg:grid-cols-12 gap-10">
            <div class="lg:col-span-7 group cursor-pointer">
              <div class="bg-white rounded-3xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300 h-full flex flex-col">
                <div class="relative overflow-hidden h-64 md:h-96 w-full">
                  <img
                    class="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                    src="https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    alt="blog image"
                  />
                  <div class="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-1 rounded-lg text-xs font-bold text-blue-600 shadow-sm">
                    TECHNOLOGY
                  </div>
                </div>

                <div class="p-8 md:p-10 flex-1 flex flex-col justify-between">
                  <div>
                    {/* <div class="flex items-center gap-4 text-sm text-gray-500 mb-4">
                                        <span class="flex items-center gap-1"><ion-icon name="calendar-outline"></ion-icon> 15 Ene, 2024</span>
                                        <span class="flex items-center gap-1"><ion-icon name="person-outline"></ion-icon> Por Admin</span>
                                    </div> */}
                    <h3 class="text-3xl md:text-4xl font-serif-display text-gray-800 mb-4 leading-tight group-hover:text-blue-500 transition-colors">
                      Our marketing and market analysis team uses advanced data
                      insights and research.
                    </h3>
                    {/* <p class="text-gray-600 leading-relaxed mb-6">
                                        Adéntrate en el mundo de Tailwind CSS con esta guía amigable. Aprende los conceptos básicos, diseño responsivo y cómo personalizar tu sitio web.
                                    </p> */}
                  </div>

                  {/* <div class="flex items-center text-teal-600 font-bold group-hover:translate-x-2 transition-transform duration-300">
                                    Leer artículo completo <ion-icon name="arrow-forward-outline" class="ml-2"></ion-icon>
                                </div> */}
                </div>
              </div>
            </div>

            <div class="lg:col-span-5 flex flex-col gap-6 justify-center">
              <article class="bg-white p-5 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group border border-gray-100 flex gap-5 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-blue-500 rounded-xl flex flex-col items-center justify-center text-white shadow-sm group-hover:bg-blue-400 group-hover:text-white transition-colors duration-300">
                  <span class="text-2xl font-bold font-serif-display leading-none">
                    13
                  </span>
                  <span class="text-[10px] uppercase font-bold tracking-wider">
                    Ene
                  </span>
                </div>

                <div class="flex-col">
                  <h4 class="text-xl font-bold text-gray-800 font-serif-display leading-tight mb-2 group-hover:text-blue-500 transition-colors">
                    Identify new customers
                  </h4>
                  {/* <p class="text-sm text-gray-500 line-clamp-2">
                                    Promote partner products and services to targeted audiences.
                                </p> */}
                </div>
              </article>

              <article class="bg-white p-5 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group border border-gray-100 flex gap-5 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-blue-500 rounded-xl flex flex-col items-center justify-center text-white shadow-sm group-hover:bg-blue-400 group-hover:text-white transition-colors duration-300">
                  <span class="text-2xl font-bold font-serif-display leading-none">
                    20
                  </span>
                  <span class="text-[10px] uppercase font-bold tracking-wider">
                    Feb
                  </span>
                </div>

                <div class="flex-col">
                  <h4 class="text-xl font-bold text-gray-800 font-serif-display leading-tight mb-2 group-hover:text-blue-500 transition-colors">
                    Expand their market share both nationally and
                    internationally
                  </h4>
                  {/* <p class="text-sm text-gray-500 line-clamp-2">
                                    Eleva tus habilidades de diseño web con trucos avanzados para interfaces impactantes.
                                </p> */}
                </div>
              </article>

              <article class="bg-white p-5 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group border border-gray-100 flex gap-5 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-blue-500 rounded-xl flex flex-col items-center justify-center text-white shadow-sm group-hover:bg-blue-400 group-hover:text-white transition-colors duration-300">
                  <span class="text-2xl font-bold font-serif-display leading-none">
                    05
                  </span>
                  <span class="text-[10px] uppercase font-bold tracking-wider">
                    Mar
                  </span>
                </div>

                <div class="flex-col">
                  <h4 class="text-xl font-bold text-gray-800 font-serif-display leading-tight mb-2 group-hover:text-blue-600 transition-colors">
                    Promote partner products and services to targeted audiences.
                  </h4>
                  {/* <p class="text-sm text-gray-500 line-clamp-2">
                                    Explora cómo simplificar el diseño móvil primero para sitios web modernos.
                                </p> */}
                </div>
              </article>

              <article class="bg-white p-5 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group border border-gray-100 flex gap-5 items-start">
                <div class="flex-shrink-0 w-16 h-16 bg-blue-500 rounded-xl flex flex-col items-center justify-center text-white shadow-sm group-hover:bg-blue-400 group-hover:text-white transition-colors duration-300">
                  <span class="text-2xl font-bold font-serif-display leading-none">
                    05
                  </span>
                  <span class="text-[10px] uppercase font-bold tracking-wider">
                    Mar
                  </span>
                </div>

                <div class="flex-col">
                  <h4 class="text-xl font-bold text-gray-800 font-serif-display leading-tight mb-2 group-hover:text-blue-500 transition-colors">
                    Partners enjoy professional marketing and sales without
                    spending on advertising.
                  </h4>
                  {/* <p class="text-sm text-gray-500 line-clamp-2">
                                    Explora cómo simplificar el diseño móvil primero para sitios web modernos.
                                </p> */}
                </div>
              </article>

              {/* <div class="mt-2 text-right">
                            <a href="#" class="inline-flex items-center text-sm font-semibold text-gray-400 hover:text-teal-600 transition-colors">
                                Ver todas las noticias <ion-icon name="arrow-forward" class="ml-1"></ion-icon>
                            </a>
                        </div> */}
            </div>
          </div>
        </section>
      </FadeInSection>
      {/* ////////////////////// */}

      {/* ///// CUSTOMERS REVIEW SECTION //// */}
      <FadeInSection>
        <TestimonialsSection />
      </FadeInSection>

      {/* ///////////// */}

      <FadeInSection>
        <PricingSection />
      </FadeInSection>

      <Footer />
    </div>
  );
};

export default Services;
